import AOS from 'aos';
import 'aos/dist/aos.css';

// content tabs init
export default function  initAOS()  {
		AOS.init({
			duration: 250,
			easing: 'cubic-bezier(.55,.055,.675,.19)',
			once: true,
			delay: 0,
			offset: 100,
			anchorPlacement: 'top-bottom'
		},);
}
